import type { RecordMetaResponse } from "@/lib/types";
import type { RecordsGatewayPort } from "@/application/records/ports/RecordsGatewayPort";

export interface FetchRecordMetaInputDto {
  recordId: string;
  include?: string[];
}

/**
 * Use case: загрузка метаданных конкретной записи.
 */
export class FetchRecordMetaUseCase {
  constructor(private readonly gateway: RecordsGatewayPort) {}

  async execute(input: FetchRecordMetaInputDto): Promise<RecordMetaResponse> {
    const { recordId, include } = input;
    return this.gateway.getRecordMeta(recordId, include);
  }
}
